export const EMAIL_REGEX = /[^\@]+@[^.]+(\.[^.]+)*/gm;
